import React, { useRef, useState, useEffect } from "react";
import "./Navbar.scss";
import { Link } from "react-router-dom";
import { BsChevronDown } from "react-icons/bs";
import { useMediaQuery } from "@mui/material";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import compliancepacksicon from "../../../assets/compliancepacksicon.png";

const NavBar = () => {
  const Desktop = useMediaQuery("(min-width:1268px)");
  const navbar = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleMega = (current) => {
    if (current === showMenu) {
      setShowMenu(0);
    } else {
      setShowMenu(current);
    }
  };
  const handlePhoneMega = (event, current) => {
    event.stopPropagation();
    if (current === showMenu) {
      setShowMenu(0);
    } else {
      setShowMenu(current);
    }
  };
  const handlePhoneMegaSecondlevel = (event, current) => {
    if (current === showMenu) {
      setShowMenu(0);
      setShowMobileMenu(!showMobileMenu);
    } else {
      setShowMenu(current);
    }
  };
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowMenu(0);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(navbar);

  return (
    <div className="Navbar">
      {Desktop ? (
        <div className="nav-wrapper">
          <div className="upper">
            <div className="logo">
              <Link to={"/"} aria-label="Britannia Pharmacy Logo">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="280"
                  height="84"
                  viewBox="0 0 280 84"
                  fill="none">
                  <path
                    d="M273.055 80.9292C273.055 80.5025 273.211 80.133 273.523 79.8206C273.836 79.5083 274.209 79.3521 274.643 79.3521C275.078 79.3521 275.451 79.5083 275.763 79.8206C276.076 80.133 276.232 80.5063 276.232 80.9406C276.232 81.3825 276.076 81.7596 275.763 82.072C275.459 82.3768 275.085 82.5291 274.643 82.5291C274.194 82.5291 273.817 82.3768 273.512 82.072C273.207 81.7673 273.055 81.3863 273.055 80.9292ZM273.352 78.2778V64.5638H275.935V78.2778H273.352Z"
                    fill="black"
                  />
                  <path
                    d="M258.843 67.0666H251.769V71.3065H258.637V73.8093H251.769V79.7063H258.843V82.2091H249.106V64.5638H258.843V67.0666Z"
                    fill="black"
                  />
                  <path
                    d="M230.448 74.6893L235.911 82.2091H232.654L227.614 74.9865H227.134V82.2091H224.471V64.5638H227.591C229.922 64.5638 231.606 65.0019 232.642 65.8781C233.785 66.8533 234.356 68.1409 234.356 69.7409C234.356 70.9904 233.998 72.0646 233.282 72.9636C232.566 73.8627 231.621 74.4379 230.448 74.6893ZM227.134 72.6665H227.979C230.501 72.6665 231.762 71.7027 231.762 69.7751C231.762 67.9695 230.536 67.0666 228.082 67.0666H227.134V72.6665Z"
                    fill="black"
                  />
                  <path
                    d="M206.956 77.9236H199.402L197.436 82.2092H194.567L203.299 63.4553L211.721 82.2092H208.807L206.956 77.9236ZM205.87 75.4208L203.253 69.4209L200.51 75.4208H205.87Z"
                    fill="black"
                  />
                  <path
                    d="M182.254 65.5124V68.6666C180.715 67.379 179.123 66.7352 177.477 66.7352C175.664 66.7352 174.136 67.3867 172.894 68.6895C171.645 69.9847 171.02 71.5694 171.02 73.4437C171.02 75.295 171.645 76.8569 172.894 78.1293C174.144 79.4016 175.675 80.0378 177.489 80.0378C178.426 80.0378 179.222 79.8854 179.877 79.5807C180.243 79.4283 180.62 79.2226 181.009 78.9635C181.405 78.7045 181.82 78.3921 182.254 78.0264V81.2378C180.73 82.0987 179.131 82.5292 177.454 82.5292C174.933 82.5292 172.78 81.6492 170.997 79.8892C169.222 78.114 168.335 75.9731 168.335 73.4665C168.335 71.2189 169.077 69.2152 170.563 67.4552C172.392 65.2991 174.757 64.221 177.66 64.221C179.245 64.221 180.776 64.6515 182.254 65.5124Z"
                    fill="black"
                  />
                  <path
                    d="M137.43 67.0666H130.356V71.3065H137.225V73.8093H130.356V79.7063H137.43V82.2091H127.693V64.5638H137.43V67.0666Z"
                    fill="black"
                  />
                  <path
                    d="M93.2073 64.5639L97.8014 76.3579L102.601 63.7068L107.195 76.3579L112.075 64.5639H114.967L107.081 83.3292L102.544 70.8266L97.8129 83.3406L90.3159 64.5639H93.2073Z"
                    fill="black"
                  />
                  <path
                    d="M265.445 44.5321L256.964 32.4438H264.18L268.498 38.7963L272.784 32.4438H280L271.489 44.5321V55.6953H265.445V44.5321Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M256.009 40.2149C254.611 38.5086 252.884 37.6554 250.828 37.6554C249.923 37.6554 249.08 37.8199 248.299 38.1488C247.538 38.4777 246.881 38.93 246.326 39.5056C245.77 40.0607 245.328 40.7289 245 41.5101C244.691 42.2913 244.537 43.1342 244.537 44.0388C244.537 44.9639 244.691 45.8171 245 46.5983C245.328 47.3795 245.77 48.0579 246.326 48.6336C246.901 49.2092 247.569 49.6615 248.33 49.9904C249.091 50.3194 249.913 50.4838 250.797 50.4838C252.729 50.4838 254.467 49.6615 256.009 48.0168V55.1711L255.392 55.387C254.467 55.7159 253.603 55.9523 252.801 56.0963C252 56.2607 251.208 56.343 250.427 56.343C248.823 56.343 247.282 56.0449 245.801 55.4487C244.342 54.8319 243.046 53.9787 241.916 52.8891C240.806 51.779 239.911 50.4735 239.233 48.9728C238.555 47.4515 238.215 45.7965 238.215 44.0079C238.215 42.2193 238.544 40.585 239.202 39.1048C239.881 37.604 240.775 36.3191 241.885 35.2501C243.016 34.1605 244.321 33.3176 245.801 32.7214C247.282 32.1046 248.834 31.7962 250.458 31.7962C251.383 31.7962 252.287 31.899 253.172 32.1046C254.076 32.2896 255.022 32.5877 256.009 32.9989V40.2149Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M228.056 47.0608L225.342 39.3206L222.629 47.0608H228.056ZM229.66 51.6556H221.025L219.637 55.6953H213.192L222.043 32.4438H228.642L237.492 55.6953H231.047L229.66 51.6556Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M182.443 55.6953L186.39 32.4438H192.372L197.029 44.8405L201.654 32.4438H207.637L211.584 55.6953H205.571L203.566 42.3118L198.077 55.6953H195.672L190.46 42.3118L188.456 55.6953H182.443Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M167.672 42.8361H168.813C170.005 42.8361 170.92 42.5894 171.557 42.096C172.195 41.6026 172.513 40.8933 172.513 39.9682C172.513 39.043 172.195 38.3338 171.557 37.8404C170.92 37.347 170.005 37.1003 168.813 37.1003H167.672V42.8361ZM180.963 55.6953H173.439L167.672 46.7524V55.6953H161.628V32.4438H171.033C172.328 32.4438 173.459 32.6391 174.425 33.0297C175.392 33.3998 176.183 33.9137 176.8 34.5716C177.437 35.2295 177.91 35.9901 178.218 36.8536C178.547 37.717 178.712 38.6422 178.712 39.629C178.712 41.397 178.28 42.8361 177.417 43.9462C176.574 45.0358 175.32 45.7759 173.654 46.1665L180.963 55.6953Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M149.547 47.0608L146.833 39.3206L144.119 47.0608H149.547ZM151.15 51.6556H142.516L141.128 55.6953H134.683L143.534 32.4438H150.133L158.983 55.6953H152.538L151.15 51.6556Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M117.26 41.4175H125.987V32.4438H132.031V55.6953H125.987V46.1049H117.26V55.6953H111.216V32.4438H117.26V41.4175Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M96.36 43.1136H98.3645C100.585 43.1136 101.695 42.1474 101.695 40.2149C101.695 38.2824 100.585 37.3161 98.3645 37.3161H96.36V43.1136ZM96.36 55.6953H90.3159V32.4438H99.9372C102.548 32.4438 104.542 33.1222 105.92 34.4791C107.318 35.8359 108.017 37.7479 108.017 40.2149C108.017 42.6819 107.318 44.5938 105.92 45.9507C104.542 47.3075 102.548 47.9859 99.9372 47.9859H96.36V55.6953Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M264.284 14.617L261.571 6.87678L258.857 14.617H264.284ZM265.888 19.2118H257.253L255.866 23.2515H249.421L258.271 0H264.87L273.721 23.2515H267.276L265.888 19.2118Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M246.784 0V23.2515H240.739V0H246.784Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M212.642 23.2515V0H218.686L229.85 14.2161V0H235.863V23.2515H229.85L218.686 9.03541V23.2515H212.642Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M184.545 23.2515V0H190.589L201.752 14.2161V0H207.766V23.2515H201.752L190.589 9.03541V23.2515H184.545Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M172.464 14.617L169.751 6.87678L167.037 14.617H172.464ZM174.068 19.2118H165.433L164.046 23.2515H157.601L166.451 0H173.05L181.901 23.2515H175.455L174.068 19.2118Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M153.252 5.11904V23.2515H147.208V5.11904H142.243V0H158.217V5.11904H153.252Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M139.575 0V23.2515H133.531V0H139.575Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M117.711 10.3923H118.852C120.045 10.3923 120.96 10.1456 121.597 9.65216C122.234 9.15876 122.553 8.44949 122.553 7.52437C122.553 6.59924 122.234 5.88998 121.597 5.39657C120.96 4.90317 120.045 4.65647 118.852 4.65647H117.711V10.3923ZM131.002 23.2515H123.478L117.711 14.3086V23.2515H111.667V0H121.073C122.368 0 123.499 0.195305 124.465 0.585914C125.431 0.955965 126.223 1.46992 126.839 2.12779C127.477 2.78566 127.95 3.54632 128.258 4.40977C128.587 5.27322 128.751 6.19835 128.751 7.18515C128.751 8.95317 128.32 10.3923 127.456 11.5024C126.613 12.592 125.359 13.3321 123.694 13.7227L131.002 23.2515Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M96.36 18.5643H97.6861C99.2074 18.5643 100.297 18.369 100.955 17.9783C101.613 17.5877 101.942 16.9607 101.942 16.0972C101.942 15.2338 101.613 14.6068 100.955 14.2162C100.297 13.8255 99.2074 13.6302 97.6861 13.6302H96.36V18.5643ZM96.36 9.12796H97.4702C99.3616 9.12796 100.307 8.37758 100.307 6.87682C100.307 5.37605 99.3616 4.62567 97.4702 4.62567H96.36V9.12796ZM90.3159 3.85879e-05H99.3205C101.459 3.85879e-05 103.083 0.513998 104.193 1.54192C105.303 2.56983 105.858 4.05004 105.858 5.98253C105.858 7.15435 105.642 8.13088 105.21 8.9121C104.799 9.67276 104.162 10.3203 103.299 10.8549C104.162 11.0193 104.892 11.2763 105.488 11.6258C106.105 11.9547 106.598 12.3659 106.968 12.8593C107.359 13.3527 107.636 13.9078 107.801 14.5245C107.965 15.1413 108.047 15.7992 108.047 16.4981C108.047 17.5877 107.852 18.554 107.462 19.3969C107.092 20.2398 106.557 20.949 105.858 21.5247C105.18 22.1003 104.347 22.532 103.36 22.8198C102.373 23.1077 101.263 23.2516 100.03 23.2516H90.3159V3.85879e-05Z"
                    fill="#003DA6"
                  />
                  <path
                    d="M68.5754 21.4564L53.1397 13.3845L39.2618 34.0598H64.327L68.5754 21.4564Z"
                    fill="#7B0828"
                  />
                  <path
                    d="M57.7744 3.85879e-05L77.2217 10.4836L71.3468 21.3818L51.8995 10.8983L57.7744 3.85879e-05Z"
                    fill="#7B0828"
                  />
                  <path
                    d="M71.089 35.7591H0L7.93024 83.3406L49.8118 83.3406L36.8544 69.0378L30.8713 75.4458H27.1894L34.8718 67.0199L28.4285 59.9039H22.7995V65.7454H19.7194V49.6725H31.898C33.3849 49.8613 36.3588 51.0178 36.3588 54.1332C36.3588 58.0276 33.6681 59.6915 32.429 59.9039L36.8544 65.0727L42.1648 59.4083H45.8113L38.8016 67.0199L53.9186 83.3406L63.1587 83.3406L71.089 35.7591Z"
                    fill="#7B0828"
                  />
                  <path
                    d="M22.7995 57.4257V52.3631H31.1192C32.1104 52.3631 33.261 53.319 33.261 55.2838C33.261 56.8557 31.8331 57.3667 31.1192 57.4257H22.7995Z"
                    fill="#7B0828"
                  />
                </svg>
              </Link>
            </div>
            <div className="links-wrapper" ref={navbar}>
              <div className="drop-down-link" onClick={() => handleMega(1)}>
                Services
                <BsChevronDown
                  style={{
                    color: "black",
                    transform: showMenu === 1 && "rotate(180deg)",
                    transition: ".3s all ease-in-out",
                  }}
                />
                {showMenu === 1 && (
                  <div className="drop-menu">
                    <Link
                      to="/services?serviceId=meds-check"
                      className="menu-box">
                      <div className="text-div">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none">
                          <path
                            d="M8.18898 8.18886L16.8114 16.8113M3.26134 13.116L13.1155 3.26183C14.2589 2.11843 15.8097 1.47607 17.4267 1.47607C19.0437 1.47607 20.5945 2.11843 21.7379 3.26183C22.8813 4.40523 23.5237 5.95602 23.5237 7.57303C23.5237 9.19004 22.8813 10.7408 21.7379 11.8842L11.8837 21.7384C10.7403 22.8818 9.18955 23.5241 7.57254 23.5241C5.95553 23.5241 4.40474 22.8818 3.26134 21.7384C2.11794 20.595 1.47559 19.0442 1.47559 17.4272C1.47559 15.8102 2.11794 14.2594 3.26134 13.116Z"
                            stroke="#003DA6"
                            stroke-width="2.01562"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="menuitemtitle">Meds Check</span>
                      </div>
                    </Link>
                    <Link
                      to="/services?serviceId=compliance-packs"
                      className="menu-box">
                      <div className="text-div">
                        <img src={compliancepacksicon} alt="pills_icon" />
                        <span className="menuitemtitle">Compliance Packs</span>
                      </div>
                    </Link>
                    <Link
                      to="/services?serviceId=Diabete-counseling"
                      className="menu-box">
                      <div className="text-div">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="31"
                          height="21"
                          viewBox="0 0 31 21"
                          fill="none">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M27.8269 10.4878L22.8331 10.4915C22.9145 10.723 22.9596 10.9724 22.9603 11.2313V11.7048C22.9603 12.435 22.6089 13.0831 22.0651 13.4878C22.2797 13.8281 22.4032 14.2321 22.404 14.6641V15.1376C22.4043 15.4291 22.3471 15.7179 22.2358 15.9873C22.1245 16.2568 21.9612 16.5016 21.7552 16.7079C21.5492 16.9143 21.3046 17.078 21.0354 17.1897C20.7661 17.3015 20.4775 17.3591 20.186 17.3593H19.7857C19.8671 17.5909 19.9122 17.8402 19.9122 18.0992L19.913 18.5726C19.9133 18.8642 19.8561 19.1529 19.7448 19.4223C19.6335 19.6918 19.4702 19.9367 19.2642 20.143C19.0582 20.3493 18.8136 20.513 18.5444 20.6248C18.2751 20.7365 17.9865 20.7942 17.695 20.7944L9.5102 20.801C4.64359 20.8047 0.695109 16.8629 0.69141 11.9963C0.689738 10.1862 1.24559 8.41944 2.28338 6.93635C3.32117 5.45327 4.79054 4.32579 6.49169 3.70721L15.3556 0.485247C15.7851 0.32907 16.2505 0.299594 16.6963 0.400325C17.1421 0.501056 17.5496 0.727753 17.8703 1.05344C19.0866 2.28896 18.619 4.36788 16.9914 4.96567L15.3009 5.5849L27.8232 5.57529C28.4747 5.5748 29.0996 5.83311 29.5606 6.29339C30.0216 6.75368 30.2808 7.37824 30.2813 8.02968C30.2818 8.68111 30.0235 9.30606 29.5632 9.76704C29.1029 10.228 28.4784 10.4873 27.8269 10.4878ZM27.824 7.05495C28.083 7.05475 28.3315 7.15745 28.5147 7.34046C28.698 7.52347 28.8011 7.77178 28.8013 8.03079C28.8015 8.28979 28.6988 8.53827 28.5158 8.72155C28.3328 8.90483 28.0845 9.00791 27.8255 9.0081H27.3209C27.322 8.98988 27.3225 8.97162 27.3224 8.95336V8.94892C27.3224 8.33634 26.6595 7.83917 25.8427 7.84065C25.0252 7.84065 24.3631 8.33856 24.3631 8.95114C24.3631 8.97111 24.3638 8.99109 24.3653 9.01032L16.6081 9.01698L16.6096 10.4966L20.7401 10.4929C20.9363 10.4929 21.1245 10.5709 21.2632 10.7096C21.402 10.8484 21.4799 11.0366 21.4799 11.2328L21.4807 11.7063C21.4807 11.9025 21.4027 12.0907 21.264 12.2294C21.1252 12.3682 20.9371 12.4461 20.7408 12.4461L16.6111 12.4498L16.6126 13.9295L20.1837 13.9265C20.38 13.9265 20.5681 14.0045 20.7069 14.1432C20.8456 14.2819 20.9236 14.4701 20.9236 14.6663L20.9243 15.1391C20.9243 15.3353 20.8464 15.5235 20.7076 15.6622C20.5689 15.801 20.3807 15.8789 20.1845 15.8789L14.9272 15.8841L14.9287 17.3638L17.6927 17.3615C17.8888 17.3615 18.0769 17.4394 18.2156 17.578C18.3543 17.7166 18.4324 17.9045 18.4326 18.1006L18.4333 18.5741C18.4333 18.7703 18.3554 18.9585 18.2166 19.0973C18.0779 19.236 17.8897 19.314 17.6935 19.314L9.50872 19.3214C5.45962 19.3243 2.17403 16.0439 2.17107 11.9948C2.1698 10.4887 2.6324 9.01868 3.49599 7.78472C4.35958 6.55076 5.58224 5.6127 6.99773 5.0981L15.8609 1.87613C16.0842 1.80262 16.3273 1.81883 16.5389 1.92133C16.7505 2.02383 16.9139 2.20459 16.9946 2.42538C17.0753 2.64618 17.067 2.88971 16.9714 3.10448C16.8758 3.31925 16.7004 3.48844 16.4824 3.57626L14.7911 4.19624C13.2382 4.76591 13.6481 7.06679 15.3016 7.06457L27.824 7.05495Z"
                            fill="#003DA6"
                          />
                        </svg>
                        <span className="menuitemtitle">
                          Diabetes Counseling
                        </span>
                      </div>
                    </Link>
                    <Link
                      to="/services?serviceId=bloodpressure-diabetesmonitoring"
                      className="menu-box">
                      <div className="text-div">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none">
                          <path
                            d="M8.18898 8.18886L16.8114 16.8113M3.26134 13.116L13.1155 3.26183C14.2589 2.11843 15.8097 1.47607 17.4267 1.47607C19.0437 1.47607 20.5945 2.11843 21.7379 3.26183C22.8813 4.40523 23.5237 5.95602 23.5237 7.57303C23.5237 9.19004 22.8813 10.7408 21.7379 11.8842L11.8837 21.7384C10.7403 22.8818 9.18955 23.5241 7.57254 23.5241C5.95553 23.5241 4.40474 22.8818 3.26134 21.7384C2.11794 20.595 1.47559 19.0442 1.47559 17.4272C1.47559 15.8102 2.11794 14.2594 3.26134 13.116Z"
                            stroke="#003DA6"
                            stroke-width="2.01562"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <span className="menuitemtitle">
                          Free Blood Pressure & Diabetes <br /> Monitoring
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
              </div>
              <div
                className="drop-down-link"
                to="/prescription"
                onClick={() => handleMega(2)}>
                Prescription
                <BsChevronDown
                  style={{
                    color: "black",
                    transform: showMenu === 2 && "rotate(180deg)",
                    transition: ".3s all ease-in-out",
                  }}
                />
                {showMenu === 2 && (
                  <div className="drop-menu">
                    <Link to="/Prescription?tab=1" className="menu-box">
                      <div className="text-div">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="29"
                          height="29"
                          viewBox="0 0 29 29"
                          fill="none">
                          <g clip-path="url(#clip0_598_8177)">
                            <path
                              d="M16.8335 4V8.66667C16.8335 8.97609 16.9564 9.27283 17.1752 9.49162C17.394 9.71042 17.6907 9.83333 18.0002 9.83333H22.6668M16.8335 4H8.66683C8.04799 4 7.4545 4.24583 7.01691 4.68342C6.57933 5.121 6.3335 5.71449 6.3335 6.33333V15.6667M16.8335 4L22.6668 9.83333M22.6668 9.83333V22.6667C22.6668 23.2855 22.421 23.879 21.9834 24.3166C21.5458 24.7542 20.9523 25 20.3335 25H13.9168"
                              stroke="#003DA6"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.636 16.748L11.838 15.224H11.832V16.748H10.5V12.5H12.48C12.824 12.5 13.118 12.562 13.362 12.686C13.606 12.806 13.788 12.972 13.908 13.184C14.032 13.392 14.094 13.628 14.094 13.892C14.094 14.176 14.014 14.428 13.854 14.648C13.698 14.868 13.472 15.026 13.176 15.122L14.1 16.748H12.636ZM11.832 14.336H12.36C12.488 14.336 12.584 14.308 12.648 14.252C12.712 14.192 12.744 14.1 12.744 13.976C12.744 13.864 12.71 13.776 12.642 13.712C12.578 13.648 12.484 13.616 12.36 13.616H11.832V14.336Z"
                              fill="#003DA6"
                            />
                            <path
                              d="M17.2255 16.748L16.4455 15.644L15.7975 16.748H14.2795L15.6775 14.558L14.2195 12.5H15.7975L16.5475 13.562L17.1715 12.5H18.6895L17.3155 14.648L18.8035 16.748H17.2255Z"
                              fill="#003DA6"
                            />
                            <path
                              d="M2.8335 23.8334H9.8335M6.3335 20.3334V27.3334"
                              stroke="#003DA6"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_598_8177">
                              <rect
                                width="28"
                                height="28"
                                fill="white"
                                transform="translate(0.5 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <span className="menuitemtitle">
                          Fill Prescription Online{" "}
                        </span>
                      </div>
                    </Link>
                    <Link to="/Prescription?tab=2" className="menu-box">
                      <div className="text-div">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="29"
                          height="29"
                          viewBox="0 0 29 29"
                          fill="none">
                          <g clip-path="url(#clip0_598_3281)">
                            <path
                              d="M16.8335 4V8.66667C16.8335 8.97609 16.9564 9.27283 17.1752 9.49162C17.394 9.71042 17.6907 9.83333 18.0002 9.83333H22.6668M16.8335 4H8.66683C8.04799 4 7.4545 4.24583 7.01691 4.68342C6.57933 5.121 6.3335 5.71449 6.3335 6.33333V15.6667M16.8335 4L22.6668 9.83333M22.6668 9.83333V22.6667C22.6668 23.2855 22.421 23.879 21.9834 24.3166C21.5458 24.7542 20.9523 25 20.3335 25H13.9168"
                              stroke="#003DA6"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.636 16.748L11.838 15.224H11.832V16.748H10.5V12.5H12.48C12.824 12.5 13.118 12.562 13.362 12.686C13.606 12.806 13.788 12.972 13.908 13.184C14.032 13.392 14.094 13.628 14.094 13.892C14.094 14.176 14.014 14.428 13.854 14.648C13.698 14.868 13.472 15.026 13.176 15.122L14.1 16.748H12.636ZM11.832 14.336H12.36C12.488 14.336 12.584 14.308 12.648 14.252C12.712 14.192 12.744 14.1 12.744 13.976C12.744 13.864 12.71 13.776 12.642 13.712C12.578 13.648 12.484 13.616 12.36 13.616H11.832V14.336Z"
                              fill="#003DA6"
                            />
                            <path
                              d="M17.2255 16.748L16.4455 15.644L15.7975 16.748H14.2795L15.6775 14.558L14.2195 12.5H15.7975L16.5475 13.562L17.1715 12.5H18.6895L17.3155 14.648L18.8035 16.748H17.2255Z"
                              fill="#003DA6"
                            />
                            <path
                              d="M9.3665 24.6111L12.1665 21.8888M12.1665 21.8888L9.3665 19.1666M12.1665 21.8888H4.4665C3.7239 21.8888 3.01171 22.1757 2.4866 22.6862C1.9615 23.1967 1.6665 23.8891 1.6665 24.6111C1.6665 25.333 1.9615 26.0255 2.4866 26.536C3.01171 27.0465 3.7239 27.3333 4.4665 27.3333H5.1665"
                              stroke="#003DA6"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_598_3281">
                              <rect
                                width="28"
                                height="28"
                                fill="white"
                                transform="translate(0.5 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <span className="menuitemtitle">
                          Prescription Refill
                        </span>
                      </div>
                    </Link>
                    <Link to="/Prescription?tab=3" className="menu-box">
                      <div className="text-div">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="29"
                          height="29"
                          viewBox="0 0 29 29"
                          fill="none">
                          <path
                            d="M16.8335 4V8.66667C16.8335 8.97609 16.9564 9.27283 17.1752 9.49162C17.394 9.71042 17.6907 9.83333 18.0002 9.83333H22.6668M16.8335 4H8.66683C8.04799 4 7.4545 4.24583 7.01691 4.68342C6.57933 5.121 6.3335 5.71449 6.3335 6.33333V15.6667M16.8335 4L22.6668 9.83333M22.6668 9.83333V22.6667C22.6668 23.2855 22.421 23.879 21.9834 24.3166C21.5458 24.7542 20.9523 25 20.3335 25H13.9168M2.8335 22.6667H11.0002M11.0002 22.6667L7.50016 19.1667M11.0002 22.6667L7.50016 26.1667"
                            stroke="#003DA6"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.3255 17.1226L11.3945 15.3446H11.3875V17.1226H9.8335V12.1666H12.1435C12.5448 12.1666 12.8878 12.239 13.1725 12.3836C13.4572 12.5236 13.6695 12.7173 13.8095 12.9646C13.9542 13.2073 14.0265 13.4826 14.0265 13.7906C14.0265 14.122 13.9332 14.416 13.7465 14.6726C13.5645 14.9293 13.3008 15.1136 12.9555 15.2256L14.0335 17.1226H12.3255ZM11.3875 14.3086H12.0035C12.1528 14.3086 12.2648 14.276 12.3395 14.2106C12.4142 14.1406 12.4515 14.0333 12.4515 13.8886C12.4515 13.758 12.4118 13.6553 12.3325 13.5806C12.2578 13.506 12.1482 13.4686 12.0035 13.4686H11.3875V14.3086Z"
                            fill="#003DA6"
                          />
                          <path
                            d="M17.6799 17.1226L16.7699 15.8346L16.0139 17.1226H14.2429L15.8739 14.5676L14.1729 12.1666H16.0139L16.8889 13.4056L17.6169 12.1666H19.3879L17.7849 14.6726L19.5209 17.1226H17.6799Z"
                            fill="#003DA6"
                          />
                        </svg>
                        <span className="menuitemtitle">
                          Prescription Transfer
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
              </div>
              <Link to="/MinorAliments">Minor Aliments</Link>
              <Link to="/Contact">Contact</Link>
            </div>
            <Link className="headerButton" to="/Prescription?tab=1">
              Fill Prescription Online
            </Link>
          </div>
        </div>
      ) : (
        <div className="mobileNav">
          <div onClick={() => setShowMobileMenu(!showMobileMenu)}>
            {showMobileMenu ? (
              <AiOutlineClose className="menu-icon" />
            ) : (
              <AiOutlineMenu className="menu-icon" />
            )}
            {showMobileMenu && (
              <div className="dropdown-links-wrapper">
                <div
                  className="drop-down-link "
                  onClick={(event) => handlePhoneMega(event, 2)}>
                  <div
                    className="supmenuparent"
                    style={{
                      color: showMenu === 2 && "#003da6",
                    }}>
                    <span>Services</span>
                    <BsChevronDown
                      style={{
                        transform: showMenu === 2 && "rotate(180deg)",
                        transition: ".3s all ease-in-out",
                      }}
                    />
                  </div>
                  {showMenu === 2 && (
                    <div
                      className="MobDrop"
                      onClick={(event) => handlePhoneMegaSecondlevel(event, 2)}>
                      <Link
                        to="/services?serviceId=meds-check"
                        className="menu-box">
                        <div className="text-div">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none">
                            <path
                              d="M8.18898 8.18886L16.8114 16.8113M3.26134 13.116L13.1155 3.26183C14.2589 2.11843 15.8097 1.47607 17.4267 1.47607C19.0437 1.47607 20.5945 2.11843 21.7379 3.26183C22.8813 4.40523 23.5237 5.95602 23.5237 7.57303C23.5237 9.19004 22.8813 10.7408 21.7379 11.8842L11.8837 21.7384C10.7403 22.8818 9.18955 23.5241 7.57254 23.5241C5.95553 23.5241 4.40474 22.8818 3.26134 21.7384C2.11794 20.595 1.47559 19.0442 1.47559 17.4272C1.47559 15.8102 2.11794 14.2594 3.26134 13.116Z"
                              stroke="#003DA6"
                              stroke-width="2.01562"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="menuitemtitle">Meds Check</span>
                        </div>
                      </Link>
                      <Link
                        to="/services?serviceId=compliance-packs"
                        className="menu-box">
                        <div className="text-div">
                          <img src={compliancepacksicon} alt="pills_icon" />
                          <span className="menuitemtitle">
                            Compliance Packs
                          </span>
                        </div>
                      </Link>
                      <Link
                        to="/services?serviceId=Diabete-counseling"
                        className="menu-box">
                        <div className="text-div">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="31"
                            height="21"
                            viewBox="0 0 31 21"
                            fill="none">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M27.8269 10.4878L22.8331 10.4915C22.9145 10.723 22.9596 10.9724 22.9603 11.2313V11.7048C22.9603 12.435 22.6089 13.0831 22.0651 13.4878C22.2797 13.8281 22.4032 14.2321 22.404 14.6641V15.1376C22.4043 15.4291 22.3471 15.7179 22.2358 15.9873C22.1245 16.2568 21.9612 16.5016 21.7552 16.7079C21.5492 16.9143 21.3046 17.078 21.0354 17.1897C20.7661 17.3015 20.4775 17.3591 20.186 17.3593H19.7857C19.8671 17.5909 19.9122 17.8402 19.9122 18.0992L19.913 18.5726C19.9133 18.8642 19.8561 19.1529 19.7448 19.4223C19.6335 19.6918 19.4702 19.9367 19.2642 20.143C19.0582 20.3493 18.8136 20.513 18.5444 20.6248C18.2751 20.7365 17.9865 20.7942 17.695 20.7944L9.5102 20.801C4.64359 20.8047 0.695109 16.8629 0.69141 11.9963C0.689738 10.1862 1.24559 8.41944 2.28338 6.93635C3.32117 5.45327 4.79054 4.32579 6.49169 3.70721L15.3556 0.485247C15.7851 0.32907 16.2505 0.299594 16.6963 0.400325C17.1421 0.501056 17.5496 0.727753 17.8703 1.05344C19.0866 2.28896 18.619 4.36788 16.9914 4.96567L15.3009 5.5849L27.8232 5.57529C28.4747 5.5748 29.0996 5.83311 29.5606 6.29339C30.0216 6.75368 30.2808 7.37824 30.2813 8.02968C30.2818 8.68111 30.0235 9.30606 29.5632 9.76704C29.1029 10.228 28.4784 10.4873 27.8269 10.4878ZM27.824 7.05495C28.083 7.05475 28.3315 7.15745 28.5147 7.34046C28.698 7.52347 28.8011 7.77178 28.8013 8.03079C28.8015 8.28979 28.6988 8.53827 28.5158 8.72155C28.3328 8.90483 28.0845 9.00791 27.8255 9.0081H27.3209C27.322 8.98988 27.3225 8.97162 27.3224 8.95336V8.94892C27.3224 8.33634 26.6595 7.83917 25.8427 7.84065C25.0252 7.84065 24.3631 8.33856 24.3631 8.95114C24.3631 8.97111 24.3638 8.99109 24.3653 9.01032L16.6081 9.01698L16.6096 10.4966L20.7401 10.4929C20.9363 10.4929 21.1245 10.5709 21.2632 10.7096C21.402 10.8484 21.4799 11.0366 21.4799 11.2328L21.4807 11.7063C21.4807 11.9025 21.4027 12.0907 21.264 12.2294C21.1252 12.3682 20.9371 12.4461 20.7408 12.4461L16.6111 12.4498L16.6126 13.9295L20.1837 13.9265C20.38 13.9265 20.5681 14.0045 20.7069 14.1432C20.8456 14.2819 20.9236 14.4701 20.9236 14.6663L20.9243 15.1391C20.9243 15.3353 20.8464 15.5235 20.7076 15.6622C20.5689 15.801 20.3807 15.8789 20.1845 15.8789L14.9272 15.8841L14.9287 17.3638L17.6927 17.3615C17.8888 17.3615 18.0769 17.4394 18.2156 17.578C18.3543 17.7166 18.4324 17.9045 18.4326 18.1006L18.4333 18.5741C18.4333 18.7703 18.3554 18.9585 18.2166 19.0973C18.0779 19.236 17.8897 19.314 17.6935 19.314L9.50872 19.3214C5.45962 19.3243 2.17403 16.0439 2.17107 11.9948C2.1698 10.4887 2.6324 9.01868 3.49599 7.78472C4.35958 6.55076 5.58224 5.6127 6.99773 5.0981L15.8609 1.87613C16.0842 1.80262 16.3273 1.81883 16.5389 1.92133C16.7505 2.02383 16.9139 2.20459 16.9946 2.42538C17.0753 2.64618 17.067 2.88971 16.9714 3.10448C16.8758 3.31925 16.7004 3.48844 16.4824 3.57626L14.7911 4.19624C13.2382 4.76591 13.6481 7.06679 15.3016 7.06457L27.824 7.05495Z"
                              fill="#003DA6"
                            />
                          </svg>
                          <span className="menuitemtitle">
                            Diabetes Counseling
                          </span>
                        </div>
                      </Link>
                      <Link
                        to="/services?serviceId=bloodpressure-diabetesmonitoring"
                        className="menu-box">
                        <div className="text-div">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none">
                            <path
                              d="M8.18898 8.18886L16.8114 16.8113M3.26134 13.116L13.1155 3.26183C14.2589 2.11843 15.8097 1.47607 17.4267 1.47607C19.0437 1.47607 20.5945 2.11843 21.7379 3.26183C22.8813 4.40523 23.5237 5.95602 23.5237 7.57303C23.5237 9.19004 22.8813 10.7408 21.7379 11.8842L11.8837 21.7384C10.7403 22.8818 9.18955 23.5241 7.57254 23.5241C5.95553 23.5241 4.40474 22.8818 3.26134 21.7384C2.11794 20.595 1.47559 19.0442 1.47559 17.4272C1.47559 15.8102 2.11794 14.2594 3.26134 13.116Z"
                              stroke="#003DA6"
                              stroke-width="2.01562"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="menuitemtitle">
                            Free Blood Pressure &<br /> Diabetes Monitoring
                          </span>
                        </div>
                      </Link>
                    </div>
                  )}
                </div>
                <div
                  className="drop-down-link "
                  onClick={(event) => handlePhoneMega(event, 1)}>
                  <div
                    className="supmenuparent"
                    style={{
                      color: showMenu === 1 && "#003da6",
                    }}>
                    <span>Prescription</span>
                    <BsChevronDown
                      style={{
                        transform: showMenu === 1 && "rotate(180deg)",
                        transition: ".3s all ease-in-out",
                      }}
                    />
                  </div>
                  {showMenu === 1 && (
                    <div
                      className="MobDrop"
                      onClick={(event) => handlePhoneMegaSecondlevel(event, 1)}>
                      <Link to="/Prescription?tab=1" className="menu-box">
                        <div className="text-div">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="29"
                            height="29"
                            viewBox="0 0 29 29"
                            fill="none">
                            <g clip-path="url(#clip0_598_8177)">
                              <path
                                d="M16.8335 4V8.66667C16.8335 8.97609 16.9564 9.27283 17.1752 9.49162C17.394 9.71042 17.6907 9.83333 18.0002 9.83333H22.6668M16.8335 4H8.66683C8.04799 4 7.4545 4.24583 7.01691 4.68342C6.57933 5.121 6.3335 5.71449 6.3335 6.33333V15.6667M16.8335 4L22.6668 9.83333M22.6668 9.83333V22.6667C22.6668 23.2855 22.421 23.879 21.9834 24.3166C21.5458 24.7542 20.9523 25 20.3335 25H13.9168"
                                stroke="#003DA6"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M12.636 16.748L11.838 15.224H11.832V16.748H10.5V12.5H12.48C12.824 12.5 13.118 12.562 13.362 12.686C13.606 12.806 13.788 12.972 13.908 13.184C14.032 13.392 14.094 13.628 14.094 13.892C14.094 14.176 14.014 14.428 13.854 14.648C13.698 14.868 13.472 15.026 13.176 15.122L14.1 16.748H12.636ZM11.832 14.336H12.36C12.488 14.336 12.584 14.308 12.648 14.252C12.712 14.192 12.744 14.1 12.744 13.976C12.744 13.864 12.71 13.776 12.642 13.712C12.578 13.648 12.484 13.616 12.36 13.616H11.832V14.336Z"
                                fill="#003DA6"
                              />
                              <path
                                d="M17.2255 16.748L16.4455 15.644L15.7975 16.748H14.2795L15.6775 14.558L14.2195 12.5H15.7975L16.5475 13.562L17.1715 12.5H18.6895L17.3155 14.648L18.8035 16.748H17.2255Z"
                                fill="#003DA6"
                              />
                              <path
                                d="M2.8335 23.8334H9.8335M6.3335 20.3334V27.3334"
                                stroke="#003DA6"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_598_8177">
                                <rect
                                  width="28"
                                  height="28"
                                  fill="white"
                                  transform="translate(0.5 0.5)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                          <span className="menuitemtitle">
                            Fill Prescription Online{" "}
                          </span>
                        </div>
                      </Link>
                      <Link to="/Prescription?tab=2" className="menu-box">
                        <div className="text-div">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="29"
                            height="29"
                            viewBox="0 0 29 29"
                            fill="none">
                            <g clip-path="url(#clip0_598_3281)">
                              <path
                                d="M16.8335 4V8.66667C16.8335 8.97609 16.9564 9.27283 17.1752 9.49162C17.394 9.71042 17.6907 9.83333 18.0002 9.83333H22.6668M16.8335 4H8.66683C8.04799 4 7.4545 4.24583 7.01691 4.68342C6.57933 5.121 6.3335 5.71449 6.3335 6.33333V15.6667M16.8335 4L22.6668 9.83333M22.6668 9.83333V22.6667C22.6668 23.2855 22.421 23.879 21.9834 24.3166C21.5458 24.7542 20.9523 25 20.3335 25H13.9168"
                                stroke="#003DA6"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M12.636 16.748L11.838 15.224H11.832V16.748H10.5V12.5H12.48C12.824 12.5 13.118 12.562 13.362 12.686C13.606 12.806 13.788 12.972 13.908 13.184C14.032 13.392 14.094 13.628 14.094 13.892C14.094 14.176 14.014 14.428 13.854 14.648C13.698 14.868 13.472 15.026 13.176 15.122L14.1 16.748H12.636ZM11.832 14.336H12.36C12.488 14.336 12.584 14.308 12.648 14.252C12.712 14.192 12.744 14.1 12.744 13.976C12.744 13.864 12.71 13.776 12.642 13.712C12.578 13.648 12.484 13.616 12.36 13.616H11.832V14.336Z"
                                fill="#003DA6"
                              />
                              <path
                                d="M17.2255 16.748L16.4455 15.644L15.7975 16.748H14.2795L15.6775 14.558L14.2195 12.5H15.7975L16.5475 13.562L17.1715 12.5H18.6895L17.3155 14.648L18.8035 16.748H17.2255Z"
                                fill="#003DA6"
                              />
                              <path
                                d="M9.3665 24.6111L12.1665 21.8888M12.1665 21.8888L9.3665 19.1666M12.1665 21.8888H4.4665C3.7239 21.8888 3.01171 22.1757 2.4866 22.6862C1.9615 23.1967 1.6665 23.8891 1.6665 24.6111C1.6665 25.333 1.9615 26.0255 2.4866 26.536C3.01171 27.0465 3.7239 27.3333 4.4665 27.3333H5.1665"
                                stroke="#003DA6"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_598_3281">
                                <rect
                                  width="28"
                                  height="28"
                                  fill="white"
                                  transform="translate(0.5 0.5)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                          <span className="menuitemtitle">
                            Prescription Refill
                          </span>
                        </div>
                      </Link>
                      <Link to="/Prescription?tab=3" className="menu-box">
                        <div className="text-div">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="29"
                            height="29"
                            viewBox="0 0 29 29"
                            fill="none">
                            <path
                              d="M16.8335 4V8.66667C16.8335 8.97609 16.9564 9.27283 17.1752 9.49162C17.394 9.71042 17.6907 9.83333 18.0002 9.83333H22.6668M16.8335 4H8.66683C8.04799 4 7.4545 4.24583 7.01691 4.68342C6.57933 5.121 6.3335 5.71449 6.3335 6.33333V15.6667M16.8335 4L22.6668 9.83333M22.6668 9.83333V22.6667C22.6668 23.2855 22.421 23.879 21.9834 24.3166C21.5458 24.7542 20.9523 25 20.3335 25H13.9168M2.8335 22.6667H11.0002M11.0002 22.6667L7.50016 19.1667M11.0002 22.6667L7.50016 26.1667"
                              stroke="#003DA6"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.3255 17.1226L11.3945 15.3446H11.3875V17.1226H9.8335V12.1666H12.1435C12.5448 12.1666 12.8878 12.239 13.1725 12.3836C13.4572 12.5236 13.6695 12.7173 13.8095 12.9646C13.9542 13.2073 14.0265 13.4826 14.0265 13.7906C14.0265 14.122 13.9332 14.416 13.7465 14.6726C13.5645 14.9293 13.3008 15.1136 12.9555 15.2256L14.0335 17.1226H12.3255ZM11.3875 14.3086H12.0035C12.1528 14.3086 12.2648 14.276 12.3395 14.2106C12.4142 14.1406 12.4515 14.0333 12.4515 13.8886C12.4515 13.758 12.4118 13.6553 12.3325 13.5806C12.2578 13.506 12.1482 13.4686 12.0035 13.4686H11.3875V14.3086Z"
                              fill="#003DA6"
                            />
                            <path
                              d="M17.6799 17.1226L16.7699 15.8346L16.0139 17.1226H14.2429L15.8739 14.5676L14.1729 12.1666H16.0139L16.8889 13.4056L17.6169 12.1666H19.3879L17.7849 14.6726L19.5209 17.1226H17.6799Z"
                              fill="#003DA6"
                            />
                          </svg>
                          <span className="menuitemtitle">
                            Prescription Transfer
                          </span>
                        </div>
                      </Link>
                    </div>
                  )}
                </div>
                <Link to="/MinorAliments">Minor Aliments</Link>
                <Link to="/Contact">Contact</Link>
              </div>
            )}
          </div>
          <div className="logo">
            <Link to={"/"} aria-label="Britannia Pharmacy Logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="280"
                height="84"
                viewBox="0 0 280 84"
                fill="none">
                <path
                  d="M273.055 80.9292C273.055 80.5025 273.211 80.133 273.523 79.8206C273.836 79.5083 274.209 79.3521 274.643 79.3521C275.078 79.3521 275.451 79.5083 275.763 79.8206C276.076 80.133 276.232 80.5063 276.232 80.9406C276.232 81.3825 276.076 81.7596 275.763 82.072C275.459 82.3768 275.085 82.5291 274.643 82.5291C274.194 82.5291 273.817 82.3768 273.512 82.072C273.207 81.7673 273.055 81.3863 273.055 80.9292ZM273.352 78.2778V64.5638H275.935V78.2778H273.352Z"
                  fill="black"
                />
                <path
                  d="M258.843 67.0666H251.769V71.3065H258.637V73.8093H251.769V79.7063H258.843V82.2091H249.106V64.5638H258.843V67.0666Z"
                  fill="black"
                />
                <path
                  d="M230.448 74.6893L235.911 82.2091H232.654L227.614 74.9865H227.134V82.2091H224.471V64.5638H227.591C229.922 64.5638 231.606 65.0019 232.642 65.8781C233.785 66.8533 234.356 68.1409 234.356 69.7409C234.356 70.9904 233.998 72.0646 233.282 72.9636C232.566 73.8627 231.621 74.4379 230.448 74.6893ZM227.134 72.6665H227.979C230.501 72.6665 231.762 71.7027 231.762 69.7751C231.762 67.9695 230.536 67.0666 228.082 67.0666H227.134V72.6665Z"
                  fill="black"
                />
                <path
                  d="M206.956 77.9236H199.402L197.436 82.2092H194.567L203.299 63.4553L211.721 82.2092H208.807L206.956 77.9236ZM205.87 75.4208L203.253 69.4209L200.51 75.4208H205.87Z"
                  fill="black"
                />
                <path
                  d="M182.254 65.5124V68.6666C180.715 67.379 179.123 66.7352 177.477 66.7352C175.664 66.7352 174.136 67.3867 172.894 68.6895C171.645 69.9847 171.02 71.5694 171.02 73.4437C171.02 75.295 171.645 76.8569 172.894 78.1293C174.144 79.4016 175.675 80.0378 177.489 80.0378C178.426 80.0378 179.222 79.8854 179.877 79.5807C180.243 79.4283 180.62 79.2226 181.009 78.9635C181.405 78.7045 181.82 78.3921 182.254 78.0264V81.2378C180.73 82.0987 179.131 82.5292 177.454 82.5292C174.933 82.5292 172.78 81.6492 170.997 79.8892C169.222 78.114 168.335 75.9731 168.335 73.4665C168.335 71.2189 169.077 69.2152 170.563 67.4552C172.392 65.2991 174.757 64.221 177.66 64.221C179.245 64.221 180.776 64.6515 182.254 65.5124Z"
                  fill="black"
                />
                <path
                  d="M137.43 67.0666H130.356V71.3065H137.225V73.8093H130.356V79.7063H137.43V82.2091H127.693V64.5638H137.43V67.0666Z"
                  fill="black"
                />
                <path
                  d="M93.2073 64.5639L97.8014 76.3579L102.601 63.7068L107.195 76.3579L112.075 64.5639H114.967L107.081 83.3292L102.544 70.8266L97.8129 83.3406L90.3159 64.5639H93.2073Z"
                  fill="black"
                />
                <path
                  d="M265.445 44.5321L256.964 32.4438H264.18L268.498 38.7963L272.784 32.4438H280L271.489 44.5321V55.6953H265.445V44.5321Z"
                  fill="#003DA6"
                />
                <path
                  d="M256.009 40.2149C254.611 38.5086 252.884 37.6554 250.828 37.6554C249.923 37.6554 249.08 37.8199 248.299 38.1488C247.538 38.4777 246.881 38.93 246.326 39.5056C245.77 40.0607 245.328 40.7289 245 41.5101C244.691 42.2913 244.537 43.1342 244.537 44.0388C244.537 44.9639 244.691 45.8171 245 46.5983C245.328 47.3795 245.77 48.0579 246.326 48.6336C246.901 49.2092 247.569 49.6615 248.33 49.9904C249.091 50.3194 249.913 50.4838 250.797 50.4838C252.729 50.4838 254.467 49.6615 256.009 48.0168V55.1711L255.392 55.387C254.467 55.7159 253.603 55.9523 252.801 56.0963C252 56.2607 251.208 56.343 250.427 56.343C248.823 56.343 247.282 56.0449 245.801 55.4487C244.342 54.8319 243.046 53.9787 241.916 52.8891C240.806 51.779 239.911 50.4735 239.233 48.9728C238.555 47.4515 238.215 45.7965 238.215 44.0079C238.215 42.2193 238.544 40.585 239.202 39.1048C239.881 37.604 240.775 36.3191 241.885 35.2501C243.016 34.1605 244.321 33.3176 245.801 32.7214C247.282 32.1046 248.834 31.7962 250.458 31.7962C251.383 31.7962 252.287 31.899 253.172 32.1046C254.076 32.2896 255.022 32.5877 256.009 32.9989V40.2149Z"
                  fill="#003DA6"
                />
                <path
                  d="M228.056 47.0608L225.342 39.3206L222.629 47.0608H228.056ZM229.66 51.6556H221.025L219.637 55.6953H213.192L222.043 32.4438H228.642L237.492 55.6953H231.047L229.66 51.6556Z"
                  fill="#003DA6"
                />
                <path
                  d="M182.443 55.6953L186.39 32.4438H192.372L197.029 44.8405L201.654 32.4438H207.637L211.584 55.6953H205.571L203.566 42.3118L198.077 55.6953H195.672L190.46 42.3118L188.456 55.6953H182.443Z"
                  fill="#003DA6"
                />
                <path
                  d="M167.672 42.8361H168.813C170.005 42.8361 170.92 42.5894 171.557 42.096C172.195 41.6026 172.513 40.8933 172.513 39.9682C172.513 39.043 172.195 38.3338 171.557 37.8404C170.92 37.347 170.005 37.1003 168.813 37.1003H167.672V42.8361ZM180.963 55.6953H173.439L167.672 46.7524V55.6953H161.628V32.4438H171.033C172.328 32.4438 173.459 32.6391 174.425 33.0297C175.392 33.3998 176.183 33.9137 176.8 34.5716C177.437 35.2295 177.91 35.9901 178.218 36.8536C178.547 37.717 178.712 38.6422 178.712 39.629C178.712 41.397 178.28 42.8361 177.417 43.9462C176.574 45.0358 175.32 45.7759 173.654 46.1665L180.963 55.6953Z"
                  fill="#003DA6"
                />
                <path
                  d="M149.547 47.0608L146.833 39.3206L144.119 47.0608H149.547ZM151.15 51.6556H142.516L141.128 55.6953H134.683L143.534 32.4438H150.133L158.983 55.6953H152.538L151.15 51.6556Z"
                  fill="#003DA6"
                />
                <path
                  d="M117.26 41.4175H125.987V32.4438H132.031V55.6953H125.987V46.1049H117.26V55.6953H111.216V32.4438H117.26V41.4175Z"
                  fill="#003DA6"
                />
                <path
                  d="M96.36 43.1136H98.3645C100.585 43.1136 101.695 42.1474 101.695 40.2149C101.695 38.2824 100.585 37.3161 98.3645 37.3161H96.36V43.1136ZM96.36 55.6953H90.3159V32.4438H99.9372C102.548 32.4438 104.542 33.1222 105.92 34.4791C107.318 35.8359 108.017 37.7479 108.017 40.2149C108.017 42.6819 107.318 44.5938 105.92 45.9507C104.542 47.3075 102.548 47.9859 99.9372 47.9859H96.36V55.6953Z"
                  fill="#003DA6"
                />
                <path
                  d="M264.284 14.617L261.571 6.87678L258.857 14.617H264.284ZM265.888 19.2118H257.253L255.866 23.2515H249.421L258.271 0H264.87L273.721 23.2515H267.276L265.888 19.2118Z"
                  fill="#003DA6"
                />
                <path
                  d="M246.784 0V23.2515H240.739V0H246.784Z"
                  fill="#003DA6"
                />
                <path
                  d="M212.642 23.2515V0H218.686L229.85 14.2161V0H235.863V23.2515H229.85L218.686 9.03541V23.2515H212.642Z"
                  fill="#003DA6"
                />
                <path
                  d="M184.545 23.2515V0H190.589L201.752 14.2161V0H207.766V23.2515H201.752L190.589 9.03541V23.2515H184.545Z"
                  fill="#003DA6"
                />
                <path
                  d="M172.464 14.617L169.751 6.87678L167.037 14.617H172.464ZM174.068 19.2118H165.433L164.046 23.2515H157.601L166.451 0H173.05L181.901 23.2515H175.455L174.068 19.2118Z"
                  fill="#003DA6"
                />
                <path
                  d="M153.252 5.11904V23.2515H147.208V5.11904H142.243V0H158.217V5.11904H153.252Z"
                  fill="#003DA6"
                />
                <path
                  d="M139.575 0V23.2515H133.531V0H139.575Z"
                  fill="#003DA6"
                />
                <path
                  d="M117.711 10.3923H118.852C120.045 10.3923 120.96 10.1456 121.597 9.65216C122.234 9.15876 122.553 8.44949 122.553 7.52437C122.553 6.59924 122.234 5.88998 121.597 5.39657C120.96 4.90317 120.045 4.65647 118.852 4.65647H117.711V10.3923ZM131.002 23.2515H123.478L117.711 14.3086V23.2515H111.667V0H121.073C122.368 0 123.499 0.195305 124.465 0.585914C125.431 0.955965 126.223 1.46992 126.839 2.12779C127.477 2.78566 127.95 3.54632 128.258 4.40977C128.587 5.27322 128.751 6.19835 128.751 7.18515C128.751 8.95317 128.32 10.3923 127.456 11.5024C126.613 12.592 125.359 13.3321 123.694 13.7227L131.002 23.2515Z"
                  fill="#003DA6"
                />
                <path
                  d="M96.36 18.5643H97.6861C99.2074 18.5643 100.297 18.369 100.955 17.9783C101.613 17.5877 101.942 16.9607 101.942 16.0972C101.942 15.2338 101.613 14.6068 100.955 14.2162C100.297 13.8255 99.2074 13.6302 97.6861 13.6302H96.36V18.5643ZM96.36 9.12796H97.4702C99.3616 9.12796 100.307 8.37758 100.307 6.87682C100.307 5.37605 99.3616 4.62567 97.4702 4.62567H96.36V9.12796ZM90.3159 3.85879e-05H99.3205C101.459 3.85879e-05 103.083 0.513998 104.193 1.54192C105.303 2.56983 105.858 4.05004 105.858 5.98253C105.858 7.15435 105.642 8.13088 105.21 8.9121C104.799 9.67276 104.162 10.3203 103.299 10.8549C104.162 11.0193 104.892 11.2763 105.488 11.6258C106.105 11.9547 106.598 12.3659 106.968 12.8593C107.359 13.3527 107.636 13.9078 107.801 14.5245C107.965 15.1413 108.047 15.7992 108.047 16.4981C108.047 17.5877 107.852 18.554 107.462 19.3969C107.092 20.2398 106.557 20.949 105.858 21.5247C105.18 22.1003 104.347 22.532 103.36 22.8198C102.373 23.1077 101.263 23.2516 100.03 23.2516H90.3159V3.85879e-05Z"
                  fill="#003DA6"
                />
                <path
                  d="M68.5754 21.4564L53.1397 13.3845L39.2618 34.0598H64.327L68.5754 21.4564Z"
                  fill="#7B0828"
                />
                <path
                  d="M57.7744 3.85879e-05L77.2217 10.4836L71.3468 21.3818L51.8995 10.8983L57.7744 3.85879e-05Z"
                  fill="#7B0828"
                />
                <path
                  d="M71.089 35.7591H0L7.93024 83.3406L49.8118 83.3406L36.8544 69.0378L30.8713 75.4458H27.1894L34.8718 67.0199L28.4285 59.9039H22.7995V65.7454H19.7194V49.6725H31.898C33.3849 49.8613 36.3588 51.0178 36.3588 54.1332C36.3588 58.0276 33.6681 59.6915 32.429 59.9039L36.8544 65.0727L42.1648 59.4083H45.8113L38.8016 67.0199L53.9186 83.3406L63.1587 83.3406L71.089 35.7591Z"
                  fill="#7B0828"
                />
                <path
                  d="M22.7995 57.4257V52.3631H31.1192C32.1104 52.3631 33.261 53.319 33.261 55.2838C33.261 56.8557 31.8331 57.3667 31.1192 57.4257H22.7995Z"
                  fill="#7B0828"
                />
              </svg>
            </Link>
          </div>
          <div className="empty"></div>
        </div>
      )}
    </div>
  );
};

export default NavBar;
